import type { ConversationAssignedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import UserIcon from "@redotech/redo-icons/user-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ConversationAssignedEvent = memo(
  function ConversationAssignedEvent({
    event,
    data,
  }: {
    event: ConversationTimelineEventResponse;
    data: ConversationAssignedEventData;
  }) {
    const description = data.assignedToMongoUserId
      ? "Conversation assigned"
      : "Conversation unassigned";

    return (
      <Flex align="flex-start" className={styles.card} dir="row" gap="sm">
        <div className={styles.icon}>
          <UserIcon />
        </div>
        <Flex className={styles.content} dir="column" gap="xxs">
          <Text fontSize="xs">{description}</Text>
          <EventTimestamp event={event} />
        </Flex>
      </Flex>
    );
  },
);
